import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useConsultantCycleHistory = (id, page = 1, term = null) => useQuery({ queryKey: ['consultant-cycle-history', id, page, term], queryFn: async () => {
    const callback = await API.get(`/consultants/${id}/cycle_history?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useConsultantCycleHistory